import React from "react";

function Pill ({  className, selected, text, onClick }) {
    return(
        <div onClick={() => {
            if (onClick) { onClick() }
        }} className={`${className} ${selected ? 'bg-[#ddbd5dCC]' : 'bg-transparent'} ${selected ? 'text-white font-bold' : 'text-black font-normal'} min-w-[120px] w-fit text-center text-xs me-2 px-2.5 py-1 rounded-md border border-gold`}>
            {text}
        </div>
    )
}

export default Pill